<template>
    <div class="layoutshop">
        <LayoutShopNavbar :shopname="selectWS.name"></LayoutShopNavbar>
        <LayoutShopActions :workshops="workshops" :selectWSid="ws_id" @on-change-workshop="onChangeWorkshops"></LayoutShopActions>
        <div class="content">
            <div id="layoutcontainer"></div>
        </div>
        <LayoutShopFooter/>
    </div>
</template>
<script>
import LayoutShopNavbar from './components/navbar.vue';
import LayoutShopActions from './components/actions.vue';
import LayoutShopFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
export default {
    components: {
        LayoutShopNavbar,
        LayoutShopActions,
        LayoutShopFooter
    },
    data() {
        return {
            Color: ['#898989', '#009900', '#C6C013', '#EF2917', '#eeeeee'], //绘制的颜色  离线，运行，待机，报警
            ws_id: Number(this.$route.params.ws_id),
            workshops: [], //所有车间
            selectWS: {}, //选择的车间
            LayoutData: {}, //布局对象
            stage: {},
            layer: {}
        };
    },
    created() {
        this.$store.commit('upNavbar', 1);
    },
    mounted() {
        //获得所有的车间
        Axios.get(AxiosUrl.workshop.select, {
            params: {
                cid: this.$store.state.user.cid
            }
        }).then(res => {
            if (res.data.code == 200) {
                this.workshops = res.data.data;
                var len = this.workshops.length;
                for (let i = 0; i < len; i++) {
                    if (this.workshops[i].ws_id == this.ws_id) {
                        this.selectWS = Object.assign({}, this.workshops[i]);
                        break;
                    }
                }
                this.getLayoutCVS();
            } else {
                console.log(res.data.msg);
            }
        });
    },
    methods: {
        //设计布局
        setCanvas() {
            // this.stage = Konva.Node.create({ attrs: { width: 0, height: 0 }, className: 'Stage' }, 'layoutcontainer');
            this.stage = Konva.Node.create(this.LayoutData, 'layoutcontainer');
            this.layer = this.stage.children[0];
            //先添加tooltip
            let tooltipLayer = new Konva.Layer();
            this.stage.add(tooltipLayer);
            let tooltip = new Konva.Label({
                opacity: 0.75,
                width: 1000,
                height: 1000,
                visible: false,
                listening: false
            });
            tooltip.add(
                new Konva.Tag({
                    fill: 'black',
                    pointerDirection: 'left',
                    pointerWidth: 10,
                    pointerHeight: 10,
                    lineJoin: 'round',
                    shadowColor: 'black',
                    shadowBlur: 10,
                    shadowOffset: 10,
                    shadowOpacity: 0.2
                })
            );
            tooltip.add(
                new Konva.Text({
                    text: '',
                    fontFamily: 'Calibri',
                    fontSize: 16,
                    padding: 5,
                    fill: 'white',
                    width: 150
                })
            );
            tooltipLayer.add(tooltip);
            //加载背景图
            let bgimage = new Image();
            bgimage.src = this.layer.children[1].attrs.imgurl;
            bgimage.onload = () => {
                this.layer.children[1].image(bgimage);
                this.layer.draw();
            };
            //加载设备块
            this.layer.children.forEach(item => {
                let _selfVue = this;
                if (item.nodeType == 'Group') {
                    item.draggable(false); //禁止拖拽
                    item.on('mouseenter', function(evt) {
                        document.body.style.cursor = 'pointer';
                        let node = evt.currentTarget;
                        if (node) {
                            // update tooltip
                            // var mousePos = node.getStage().getPointerPosition();
                            if (node.x() > _selfVue.stage.width() / 2) {
                                tooltip.children[0].pointerDirection('right');
                                tooltip.position({
                                    x: node.x() + -5,
                                    y: node.y() + node.height() / 2
                                });
                            } else {
                                tooltip.children[0].pointerDirection('left');
                                tooltip.position({
                                    x: node.x() + node.width() + 5,
                                    y: node.y() + node.height() / 2
                                });
                            }
                            //如果设备从车间删除，而布局没有改变，就会报错
                            if (node.attrs.detail) {
                                tooltip.getText().text(`${_selfVue.$t('deviceName')}:\n${node.attrs.detail.name}\n${_selfVue.$t('b_mainDevice')}:\n${node.attrs.detail.main_name}\n${_selfVue.$t('b_serialTBOX')}:\n${node.attrs.detail.main_serial}`);
                            } else {
                                tooltip.getText().text(`${_selfVue.$t('a_deleted')}`);
                            }
                            tooltip.show();
                            tooltipLayer.batchDraw();
                        }
                    });
                    item.on('mouseleave', function() {
                        document.body.style.cursor = 'default';
                        tooltip.hide();
                        tooltipLayer.draw();
                    });
                    item.on('dblclick', function() {
                        var gid = this.name().replace(/\D/g, '');
                        // window.open(`http://${window.location.host}/#/oeetable/${gid}`, '', 'height=1000, width=1800, toolbar=no, menubar=no, scrollbars=yes, resizable=yes');
                        _selfVue.$router.push({ path: `/oeetable/${gid}` });
                    });
                    //显示图片
                    var imageObj = new Image();
                    imageObj.onload = () => {
                        item.children[1].children[0].image(imageObj);
                        this.layer.draw();
                    };
                    imageObj.src = item.children[1].children[0].attrs.imgurl;
                }
            });
        },
        //获取车间状态
        getCurrentstate() {
            Axios.get(AxiosUrl.group.status, {
                params: {
                    ws_id: this.ws_id,
                    cid: this.$store.state.user.cid
                }
            }).then(res => {
                if (res.data.code == 200) {
                    let data = res.data.data;
                    data.forEach(item => {
                        let [rect] = [...this.stage.find(`.Rect${item.gid}`)];
                        if (rect != undefined) {
                            rect.fill(this.Color[item.status]);
                            rect.parent.attrs.detail = item;
                        }
                    });
                    this.layer.draw();
                } else {
                    console.error(res.data.msg);
                }
            });
        },
        //获取车间的布局
        getLayoutCVS() {
            //获取车间布局的接口
            Axios.get(AxiosUrl.workshop.layoutinfo, {
                params: {
                    ws_id: this.ws_id
                }
            }).then(res => {
                if (res.data.code == 200) {
                    let shopJSON = res.data.data.layout;
                    if (shopJSON.length < 10) {
                        if (this.stage == {}) {
                            return;
                        } else {
                            if ('clear' in this.stage) {
                                this.stage.clear();
                            }
                            return;
                        }
                    }
                    //开始设计布局
                    this.LayoutData = JSON.parse(shopJSON);
                    //获取状态
                    this.getCurrentstate();
                    this.setCanvas();
                    let currentstateIntval = setInterval(() => {
                        this.getCurrentstate();
                    }, 2000); // 定时刷新机组
                    this.$once('hook:beforeDestroy', () => {
                        clearInterval(currentstateIntval);
                    });
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        onChangeWorkshops(id) {
            this.ws_id = id;
            var len = this.workshops.length;
            for (let i = 0; i < len; i++) {
                if (this.workshops[i].ws_id == this.ws_id) {
                    this.selectWS = Object.assign({}, this.workshops[i]);
                    break;
                }
            }
            this.getLayoutCVS();
        }
    }
};
</script>
<style lang="less">
.layoutshop {
    .content {
        display: flex;
        justify-content: center;
        padding-top: 10px;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/layoutshop/layoutshop.vue